import { getToken } from '../stores/authStore';

/**
 * WebSocket subprotocols for an authenticated Encore stream. Browsers can't set an Authorization
 * header on the upgrade request, so Encore reads headers from an `encore.dev.headers.<base64url>`
 * subprotocol (the same encoding the generated client uses).
 */
export function authedWebSocketProtocols(): string[] {
  const token = getToken();
  if (!token) return ['encore-ws'];
  const encoded = btoa(JSON.stringify({ authorization: `Bearer ${token}` }))
    .replaceAll('=', '')
    .replaceAll('+', '-')
    .replaceAll('/', '_');
  return ['encore-ws', `encore.dev.headers.${encoded}`];
}
